'use client';

import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';

// PDF mapping for each day (1-6)
const PDF_FILES = {
  1: 'https://healthylivingproject.ams3.cdn.digitaloceanspaces.com/schemas/1-daags%20Programma%20-%20The%20Essential%20-%20StrongR%20By%20Stef.pdf',
  2: 'https://healthylivingproject.ams3.cdn.digitaloceanspaces.com/schemas/2-daags%20Programma%20-%20Foundation%20Builder%20-%20StrongR%20By%20Stef.pdf',
  3: 'https://healthylivingproject.ams3.cdn.digitaloceanspaces.com/schemas/3-daags%20Programma%20-%20Triple%20Threat%20-%20StrongR%20By%20Stef.pdf',
  4: 'https://healthylivingproject.ams3.cdn.digitaloceanspaces.com/schemas/4-daags%20Programma%20-%20The%20Fource%20-%20StrongR%20By%20Stef.pdf',
  5: 'https://healthylivingproject.ams3.cdn.digitaloceanspaces.com/schemas/5-daags%20Programma%20-%20Full%20Week%20Gains%20-%20StrongR%20By%20Stef.pdf'
};

const DownloadTrainingsplan = () => {
  const [searchParams] = useSearchParams();
  const [isLoading, setIsLoading] = useState(false);
  const [totalDays, setTotalDays] = useState(0);
  const [email, setEmail] = useState('');
  
  // Get email and days from URL query parameters
  useEffect(() => {
    setEmail(searchParams.get('email') || '');
    console.log(searchParams.get('days'));
    let days = searchParams.get('days') || '3';
    days = days.replace(' dagen per week', '');
    days = days.replace('%20dagen%20per%20week', '');
    days = parseInt(days, 10);
    setTotalDays(days);
    console.log(days);
  }, [searchParams]);

  // Make.com webhook URL - replace with your actual webhook URL
  const WEBHOOK_URL = 'https://hook.eu2.make.com/sqjjr35iamrmytl0gjwc3mnc0l2545vf';

  // Function to send event to Make.com
  const sendWebhookEvent = async (eventType) => {
    try {
      await fetch(WEBHOOK_URL, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          email: email,
          event: eventType,
          days: totalDays,
          timestamp: new Date().toISOString(),
        }),
      });
    } catch (error) {
      console.error('Error sending webhook:', error);
    }
  };

  // Send page_visit event on page load
  useEffect(() => {
    if (email) {
      sendWebhookEvent('page_visit');
    }
  }, [email]);

  // Handle PDF download
  const handleDownload = async () => {
    setIsLoading(true);
    
    // Send plan_downloaded event
    if (email) {
      await sendWebhookEvent('plan_downloaded');
    }
    
    // Trigger PDF download
    const link = document.createElement('a');
    link.href = PDF_FILES[totalDays];
    link.download = `trainingsplan-${totalDays}-dagen.pdf`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    
    setIsLoading(false);
  };

  return (
    <div className="container mx-auto px-4 section-padding pt-[180px] pb-[90px]">
      <div className="max-w-3xl mx-auto text-center">
        {/* Title */}
        <h1 className="text-black text-4xl md:text-5xl font-bold mb-6">
          Download je gratis trainingsplan
        </h1>
        
        {/* Subtitle */}
        <p className="text-black text-xl md:text-2xl mb-12">
          Om je op weg te helpen, ontvang je van mij een gratis {totalDays}-daags trainingsplan
        </p>
        
        {/* Download Button */}
        <button
          onClick={handleDownload}
          disabled={isLoading}
          className="bg-primary-red text-white px-12 py-8 rounded-[10px] font-bold text-xl flex space-x-3 items-center justify-center mx-auto transform transition-transform duration-300 hover:scale-105 hover:shadow-xl disabled:opacity-50 disabled:cursor-not-allowed"
        >
          {isLoading ? (
            <>
              <svg className="animate-spin h-6 w-6 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
              </svg>
              <span>Downloaden...</span>
            </>
          ) : (
            <>
              <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4" />
              </svg>
              <span>Download Trainingsplan</span>
            </>
          )}
        </button>
        
        {/* Additional info */}
        <p className="text-gray-600 text-sm mt-8">
          Het {totalDays}-daagse trainingsplan wordt direct gedownload naar je apparaat
        </p>
      </div>
    </div>
  );
};

export default DownloadTrainingsplan;